import { z } from 'zod';

export const ACCOUNT_REGIONS = ['ES', 'ES-CN', 'ES-CT'] as const;
export const ACCOUNT_LANGUAGES = ['es-ES', 'ca-ES'] as const;

/**
 * Validation schema for the Create Account form.
 * Mirrors the backend `RegisterAccountRequest` schema in `etc/openapi/admin.yaml`.
 */
export const accountCreateSchema = z.object({
  businessName: z
    .string()
    .min(2, 'Business name must be at least 2 characters')
    .max(100, 'Business name must be at most 100 characters'),
  ownerFirstName: z
    .string()
    .min(1, 'Owner first name is required')
    .max(50, 'Owner first name must be at most 50 characters'),
  ownerLastName: z
    .string()
    .min(1, 'Owner last name is required')
    .max(100, 'Owner last name must be at most 100 characters'),
  email: z.string().email('Must be a valid email address'),
  region: z.enum(ACCOUNT_REGIONS, {
    errorMap: () => ({ message: 'Please select a region' }),
  }),
  language: z.enum(ACCOUNT_LANGUAGES, {
    errorMap: () => ({ message: 'Please select a language' }),
  }),
});

export type AccountCreateFormValues = z.infer<typeof accountCreateSchema>;
